export const LOCAL = 'local';
export const DEMO = 'demo';
export const PREPROD = 'preprod';
export const PROD = 'prod';
